import MetaInfoListItem from "components/MetaInfoList/Item";
import TriggerByInfo from "components/TriggerByInfo";
import { Run, VcsProvider } from "types/generated";
import Timestamp from "components/Timestamp";

import RunTriggerCommit from "../RunTriggerCommit";

type RunMetaInfoListItemProps = {
  run: Run;
  stackId: string;
  provider: VcsProvider;
};

const RunMetaInfoListItem = ({ run, stackId, provider }: RunMetaInfoListItemProps) => (
  <MetaInfoListItem fullWidth>
    <RunTriggerCommit triggeredBy={run.triggeredBy || undefined} />
    {run.finished ? "finished on" : "started on"}{" "}
    <Timestamp timestamp={run.finished ? run.updatedAt : run.createdAt} />
    {run.finished ? ", started " : " "}
    <TriggerByInfo
      stackId={stackId}
      triggeredBy={run.triggeredBy || undefined}
      driftDetection={run.driftDetection}
      provider={provider}
    />
  </MetaInfoListItem>
);

export default RunMetaInfoListItem;
